export function accordion() {
    let expandedAttr = "aria-expanded";
    let accordionClassName = "accordion";
    let accordionSelector = "." + accordionClassName;
    let itemSelector = ".accordion-item";
    let itemInnerSelector = ".hidden";
    let itemButtonSelector = ".trigger";
    let activeClass = "active";

    let accordionItem = function (accordionButton) {
        let item = accordionButton.closest(itemSelector);
        let itemsOther = item.closest(accordionSelector).find(itemSelector).not(item); //item.siblings();
        let isActive = item.hasClass(activeClass);

        itemsOther.removeClass(activeClass).children(itemInnerSelector).slideUp();
        itemsOther.children(itemButtonSelector).attr(expandedAttr, false);
        item[`${isActive ? "remove" : "add"}Class`](activeClass).children(itemInnerSelector).slideToggle();
        item.children(itemButtonSelector).attr(expandedAttr, !isActive);
    };

    let initAccordion = function (accordions) {
        $("body").on("click", ".trigger", function (e) {
            e.preventDefault();
            accordionItem($(this));
        });
        accordions.each(function () {
            let accordion = $(this);
            if (!accordion.hasClass("closed-first")) {
                accordion.find(itemSelector + ":first" + " " + itemButtonSelector).trigger("click");
            }
        });
    };

    initAccordion($(accordionSelector));
}


// WEBPACK FOOTER //
// ./assets/js/modules/accordion.js